<template>
  <div class="home-container">
    <div class="home-content">
      <div style="margin: 20px">
         <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
        <el-button
          size="small"
          plain
          type="primary"
          @click="back"
          style="width: 90px"
          >返回</el-button
        >
      </div>
      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="ridgepoleName" label="楼栋信息" align="center">
        </el-table-column>
        <el-table-column prop="unitName" label="单元信息" align="center">
        </el-table-column>        
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>        
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="50%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
         <el-row>
            <el-col :span="24">
              <el-form-item label="楼栋信息" prop="name">
                 <el-select
                  v-model="addData.ridgepoleId"
                  clearable filterable
                  placeholder="请选择"
                  @change="ridgepoleSelect"
                >
                  <el-option
                    v-for="item in ridgepoleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="addData.ridgepoleId"> 
          <el-col :span="24">
              <el-form-item label="单元信息" prop="name">
                 <el-select
                  v-model="addData.unitId"
                  multiple
                  clearable filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in unitList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>                                               
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>        
      </div>
    </div>
  </div>
</template>

<script>
import reg from '../../utils/reg'
export default {
    props:{
     build:Object   
    },
  data() {
    return {
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      tableData: [],
      addData: {
        id: "",
        ridgepoleId:'',
        unitId:''
      },
      addDataRules: {
        ridgepoleId: [{ required: true, message: "请选择楼栋", trigger: "blur" }],
        unitId: [{ required: true, message: "请选择单元", trigger: "blur" }],
      },      
      isShowloading:false,
      isAddModal:false,
      btnLoading:false,
      modalTitle:"",
      ridgepoleList:[],
      unitList:[]
    };
  },
  mounted() {
     this.onLoad();
  },
  methods: {
    // 选择楼栋
    ridgepoleSelect(e){
      this.$Apis.unitAllList({ridgepoleId:e}).then(res=>{
        if(res.code == 200){
          this.unitList = res.data
        }
      })
    },    
    // 返回活动列表
    back(){
        this.$emit('buildBack',true)
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 新增
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.modalTitle = "新增"; 
      this.isAddModal = true;
    },  
    // 修改角色
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.isAddModal = true;
    },  
    //删除
    del(row) {
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let data = {
            id:this.build.id,
            unitId:row.unitId
        }
        this.$Apis.deleteManageRidgepole(data).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },    
    // 提交
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          var data = {
            id: this.build.id || "",
            unitIds:this.addData.unitId.join(','),
            userType: this.build.userType
          };
          this.$Apis.saveManageRidgepole(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },        
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },    
    onLoad() {
      var data = {
        current: this.currentPage,
        size: this.pageSize,
        id:this.build.id,
        userType:this.build.userType,
      }
      this.$Apis.houseAllList().then(res=>{
        if(res.code == 200){
          this.ridgepoleList = res.data
        }
      })      
      this.$Apis.manageRidgepole(data).then(res=>{
        if (res.code == 200) {
        //   let { current, list, pages, total } = res.data;
        //   this.currentPage = current;
        //   this.size = pages;
        //   this.total = total;
          this.tableData = res.data;
        } else {
          this.$message.warning(res.msg);
        }
      })
    },
  },
};
</script>

<style>
</style>